// src/services/activityService.js
import { api } from './api';

// Get activities for a project
export const getProjectActivities = async (projectId, params = {}) => {
  const queryParams = new URLSearchParams();
  
  // Add pagination params
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  
  // Add sort params
  if (params.sort) queryParams.append('sort', params.sort);
  
  // Add filter params
  if (params.entityType) queryParams.append('entityType', params.entityType);
  if (params.activityType) queryParams.append('activityType', params.activityType);
  if (params.search) queryParams.append('search', params.search);
  
  const queryString = queryParams.toString();
  return api.get(`/projects/${projectId}/activities${queryString ? `?${queryString}` : ''}`);
};

// Get activities for a task
export const getTaskActivities = async (taskId, params = {}) => {
  const queryParams = new URLSearchParams();
  
  // Add pagination params
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  
  // Add sort params
  if (params.sort) queryParams.append('sort', params.sort);
  
  // Add filter params
  if (params.activityType) queryParams.append('activityType', params.activityType);
  if (params.search) queryParams.append('search', params.search);
  
  const queryString = queryParams.toString();
  return api.get(`/tasks/${taskId}/activities${queryString ? `?${queryString}` : ''}`);
};

// Get user's recent activities
export const getUserActivities = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  // Add pagination params
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  
  // Add filter params
  if (params.entityType) queryParams.append('entityType', params.entityType);
  if (params.activityType) queryParams.append('activityType', params.activityType);
  if (params.search) queryParams.append('search', params.search);
  
  const queryString = queryParams.toString();
  return api.get(`/activities/me${queryString ? `?${queryString}` : ''}`);
};